export const LcgBlue = "#004FFE";
export const LcgGreen = "#D4FFEB";
